import BuyersFilterContent from "./Buyers";
import ContractDatesFilterContent from "./ContractDates";
import ContractValueFilterContent from "./ContractValue";
import CPVCodeFilterContent from "./CPVCode";
import FrameworkFilterContent from "./Framework";
import KeywordsFilterContent from "./Keywords";
import ProcurementStageFilterContent from "./ProcurementStage";
import SignalScoreFilterContent from "./SignalScore";
import SuppliersFilterContent from "./Suppliers";

export const frameworkFilterContents = {
  keywords: KeywordsFilterContent,
  signalScores: SignalScoreFilterContent,
  procurementStage: ProcurementStageFilterContent,
  framework: FrameworkFilterContent,
  buyers: BuyersFilterContent,
  suppliers: SuppliersFilterContent,
  contractDates: ContractDatesFilterContent,
  contractValue: ContractValueFilterContent,
  cpvCode: CPVCodeFilterContent,
};
